import { Lang } from 'Roblox';

const promotedChannelsResources = Lang.PromotedChannelsResources || {};

const translationConstants = {
  'Message.SocialLinkoffPlatformModalTitle':
    promotedChannelsResources['Message.SocialLinkoffPlatformModalTitle'] ||
    'You are leaving Roblox',
  'Message.SocialLinkoffPlatformModalBody':
    promotedChannelsResources['Message.SocialLinkoffPlatformModalBody'] ||
    'Heads up, Robloxian – by clicking “continue,” you will be redirected to a retail website that is not owned or operated by Roblox. They may have different terms and privacy policies.{lineBreak} Please note that you need to be over 18 to purchase products online. We hope to see you again soon!',
  'Message.SocialLinkoffPlatformModalContinueButtonText':
    promotedChannelsResources['Message.SocialLinkoffPlatformModalContinueButtonText'] || 'Continue',
  'Message.SocialLinkoffPlatformModalCancelButtonText':
    promotedChannelsResources['Message.SocialLinkoffPlatformModalCancelButtonText'] || 'Cancel'
};

let socialLinksJumbotron = angular
  .module('socialLinksJumbotron', [
    'robloxApp',
    'socialLinksCommon',
    'socialLinksJumbotronHtmlTemplateApp',
    'modal'
  ])
  .config([
    'languageResourceProvider',
    function (languageResourceProvider) {
      languageResourceProvider.setLanguageKeysFromFile(translationConstants);

      if (Lang.PromotedChannelsResources) {
        languageResourceProvider.setLanguageKeysFromFile(Lang.PromotedChannelsResources);
      }
    }
  ]);

export default socialLinksJumbotron;
